import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  Button,
  IconButton
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import apilink from "../globals/Baseurls";
import user1 from "./user1.jpeg";

export default function Matches() {
  const [tab, setTab] = useState(1);
  const [onview, setOnview] = useState("all");
  const [matches, setMatches] = useState([]);
  const [matchesfilter, setMatchesfilter] = useState([]);
  const navigate = useNavigate();

  const fetchMatches = async () => {
    try {
      const { token } = JSON.parse(localStorage.getItem("userSessionData"));
      const res = await axios.get(`${apilink.link}/matches`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res.data);
      setMatches(res.data);
      setMatchesfilter(res.data);
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Failed to load matches");
    }
  };

  useEffect(() => {
    fetchMatches();
  }, []);

  const startChat = async (match) => {
   
    try {
      match.navto = "chat";
      const { token } = JSON.parse(localStorage.getItem("userSessionData"));
      const res = await axios.post(
        `${apilink.link}/chats/${match.match_id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
     
      localStorage.setItem("chatSessionData", JSON.stringify(match));
      navigate(`/chat`)
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Failed to start chat");
    }
  };

  const viewProfile = async (match) => {
    try {
      match.navto = "matches";
      localStorage.setItem("chatSessionData", JSON.stringify(match));
      navigate(`/user-profile`)
    } catch (err) {
      console.error(err.message);
    }
  };

  const cancelMatch = async (userId) => {
    // if (confirm("Confirm you are cancelling this match?")){
    //   console.log("first");
    // }
    try {
      const { token } = JSON.parse(localStorage.getItem("userSessionData"));
      await axios.delete(`${apilink.link}/matches/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // remove from local state
      setMatches((prev) => prev.filter((m) => m.user_id !== userId));
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Failed to cancel match");
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fff7f8", pb: 12 }}>

      {/* 🔝 Sticky Top Bar */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 20,
          bgcolor: "#fff",
          p: 2,
          borderBottom: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Back button */}
        <IconButton onClick={() => navigate("/activity")}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6">Matches</Typography>
        <IconButton onClick={() => { if (onview === "all") { setOnview("new") } else { setOnview("all") } }}>
          <FilterListIcon />
        </IconButton>
      </Box>

      <List sx={{ mt: 1 }}>
        {matches.map((m, i) => (
          <ListItem
            key={i}
            divider

            sx={{
              px: 2,
              py: 1.5,
              bgcolor: "#fff7f8",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* Profile Pic */}
            <Box
              component="img"
              src={m.photo ? `${apilink.base_link}/storage/${m.photo}` : user1}
              alt={m.name}
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                objectFit: "cover",
                mr: 2,
              }}
              onClick={() => viewProfile(m)}
            />

            {/* Text + Buttons */}
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight="bold">{m.name}</Typography>
              <Typography variant="body2" color="text.secondary">
                Matched on {new Date(m.matched_at).toLocaleDateString()} •{" "}
                {new Date(m.matched_at).toLocaleTimeString()}
              </Typography>

              <Box mt={1}>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ height: "25px", fontSize: 11 }}
                  onClick={() => startChat(m)}
                >
                  {/* Go To Chat or Start Chat */}
                  {m.conversation_id === null ? "Start Chat" : "Go To Chat"}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ ml: 1, borderColor: "#010832", color: "#010832", height: "25px", fontSize: 11 }}
                  onClick={() => cancelMatch(m.user_id)}
                >
                  Cancel Match
                </Button>
              </Box>
            </Box>
          </ListItem>
        ))}
      </List>

     
    </Box>
  );
}


